export enum ThresholdLevel {
  MinLow = 'Min-Low',
  MaxLow = 'Max-Low',
  MinMedium = 'Min-Medium',
  MaxMedium = 'Max-Medium',
  MinHigh = 'Min-High',
  MaxHigh = 'Max-High',
}

export interface IThresholdLevel {
  id: string;
  name: string;
}

export class LocationDataProcessMeasure {
  id?: string;
  type?: string;
  project_device_location?: number;
  effected_at?: string;
  start_date?: string;
  end_date?: string;
  value?: number;
  comment?: string;
  invertedDirection?: boolean;
  selected?: boolean;
  thresholdLevel?: IThresholdLevel;
}
